export default {
  title: 'purple',

  colors: {
    twitter: 'rgb(124, 74, 201)',
    darkhover: '#0C0814',
    lighthover: '#252433',
  },
};